module.exports = __webpack_public_path__ + "static/media/senionHighSchool-2-7.6b83df31.png";